
    import '/Users/lijixiang/Work/power-design/site/docs/mobile/index.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-mobile-demo-quickstart"],
  getter: () => import(/* webpackChunkName: "meta__docs" */'/Users/lijixiang/Work/power-design/site/docs/mobile/index.md?type=demo')
};